var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Development-Plan",
    transform: "translate(-1093.000000, -534.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(1093.000000, 534.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2974C1",
    opacity: 0.100245276,
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(9.000000, 9.000000)",
    fill: "#195477"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41064146,2.0035122 L0.808080488,8.60656098 C0.774860976,8.63985366 0.750885366,8.68195122 0.739446341,8.72714634 L0.00761707317,11.664561 C-0.0142609756,11.753 0.0117146341,11.8470244 0.0762512195,11.911561 C0.125080488,11.9603902 0.191617073,11.9874146 0.259665854,11.9874146 C0.280495122,11.9874146 0.301836585,11.9848537 0.322568293,11.9796098 L3.25998293,11.2476829 C3.30576341,11.2362439 3.34734878,11.2123659 3.38059268,11.1791707 L9.98371463,4.57658537 L7.41064146,2.0035122 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6194585,1.10321707 L10.8844829,0.368241463 C10.3932878,-0.122978049 9.53714146,-0.122490244 9.04650732,0.368241463 L8.14619024,1.26853415 L10.7191659,3.84153415 L11.6194585,2.94121707 C11.8648488,2.69594878 11.9999951,2.36948537 11.9999951,2.02226585 C11.9999951,1.67504634 11.8648488,1.34858293 11.6194585,1.10321707",
    id: "Fill-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0a7aaaed.svg";
export { ForwardRef as ReactComponent };